import React from 'react';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';
import { FL_DESCRIPTION, FL_TITLE } from "../../../components/i18n/formLabels";
import { PH_DESCRIPTION, PH_TITLE } from "../../../components/i18n/placeHolders";
import {LangController} from "../../../components/tabs/langController";

const ProgramLangs = props => {
    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name },
            title: '',
            description: '',
        }) )
        setLangChilds(items);
    }

    const getFormulary = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md="12">
                <FormGroup>
                    <Label >{ FL_TITLE }</Label>
                    <Input type="text"
                           name="title"
                           placeholder={ PH_TITLE }
                           value= { child.title || '' }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label >{ FL_DESCRIPTION }</Label>
                    <Input type="textarea" name="description"
                           rows="10"
                           placeholder={ PH_DESCRIPTION }
                           value= { child.description || '' }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>

    return(<LangController
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
        translatableLangs={props.translatableLangs}
    />)
}

export default ProgramLangs;